import { Controller } from '@hotwired/stimulus';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['intervalSwitch', 'monthPrice', 'yearPrice'];

  onIntervalSwitchClick() {
    if (this.intervalSwitchTarget.checked) {
      this.monthPriceTargets.forEach((target) => {
        target.classList.add('hidden');
      });
      this.yearPriceTargets.forEach((target) => {
        target.classList.remove('hidden');
      });
    } else {
      this.yearPriceTargets.forEach((target) => {
        target.classList.add('hidden');
      });
      this.monthPriceTargets.forEach((target) => {
        target.classList.remove('hidden');
      });
    }
  }
}
